import { Mail, MessageCircle, Instagram } from "lucide-react";
import { NAV_LINKS } from "./shared";

export default function Footer() {
  return (
    <footer className="bg-[#1B1915] text-[#FDFBF7]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 pb-16 border-b border-[#FDFBF7]/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <img
                src="/assets/logo.png"
                alt="ELYNCOR ELEMENTS logo"
                className="w-12 h-12 rounded-full bg-[#FDFBF7] p-1.5"
                data-testid="footer-logo-image"
              />
              <h2 className="font-serif-display text-2xl tracking-[0.12em]" data-testid="footer-brand">
                ELYNCOR ELEMENTS
              </h2>
            </div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#FDFBF7]/50 mb-3" data-testid="footer-product-line">
              7 Chakra Crystal Tree
            </p>
            <p className="font-serif-display italic text-lg text-[#C6A15B]" data-testid="footer-tagline">
              Nature • Energy • Harmony
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href="mailto:elyncorelements@zohomail.in"
                className="inline-flex items-center gap-2.5 px-6 py-3 rounded-full bg-[#FDFBF7] text-[#1B1915] text-[12px] tracking-[0.16em] uppercase hover:bg-[#C6A15B] transition-colors duration-300"
                data-testid="footer-email-button"
              >
                <Mail size={15} /> Email Us
              </a>
              <a
                href="https://wa.me/917733011368"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2.5 px-6 py-3 rounded-full border border-[#FDFBF7]/30 text-[12px] tracking-[0.16em] uppercase hover:border-[#FDFBF7] hover:bg-[#FDFBF7]/5 transition-colors duration-300"
                data-testid="footer-whatsapp-button"
              >
                <MessageCircle size={15} /> WhatsApp
              </a>
              <a
                href="https://instagram.com/elyncorelements"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2.5 px-6 py-3 rounded-full border border-[#FDFBF7]/30 text-[12px] tracking-[0.16em] uppercase hover:border-[#FDFBF7] hover:bg-[#FDFBF7]/5 transition-colors duration-300"
                data-testid="footer-instagram-button"
              >
                <Instagram size={15} /> Instagram
              </a>
            </div>
          </div>

          <div className="lg:col-span-4">
            <p className="text-[11px] tracking-[0.26em] uppercase text-[#C6A15B] mb-6">Contact</p>
            <a
              href="mailto:elyncorelements@zohomail.in"
              className="block text-base text-[#FDFBF7]/85 hover:text-[#FDFBF7] transition-colors duration-300 mb-6"
              data-testid="footer-email-link"
            >
                elyncorelements@zohomail.in
            </a>
            <a
              href="https://instagram.com/elyncorelements"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-base text-[#FDFBF7]/85 hover:text-[#FDFBF7] transition-colors duration-300 mb-6 -mt-3"
              data-testid="footer-instagram-link"
            >
              <Instagram size={15} className="text-[#C6A15B]" /> @elyncorelements
            </a>
            <div className="space-y-4" data-testid="footer-founders">
              <div className="flex items-baseline justify-between max-w-xs">
                <span className="font-serif-display text-lg">Daksh</span>
                <a href="tel:+917733011368" className="text-sm text-[#FDFBF7]/70 hover:text-[#FDFBF7] transition-colors duration-300" data-testid="footer-phone-daksh">
                  +91 7733011368
                </a>
              </div>
              <div className="flex items-baseline justify-between max-w-xs">
                <span className="font-serif-display text-lg">Shivam</span>
                <a href="tel:+918076601010" className="text-sm text-[#FDFBF7]/70 hover:text-[#FDFBF7] transition-colors duration-300" data-testid="footer-phone-shivam">
                  +91 8076601010
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[11px] tracking-[0.26em] uppercase text-[#C6A15B] mb-6">Explore</p>
            <nav className="flex flex-col gap-3" data-testid="footer-nav">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="text-sm text-[#FDFBF7]/65 hover:text-[#FDFBF7] transition-colors duration-300"
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="overflow-hidden -mb-2" aria-hidden="true">
          <p
            className="font-serif-display text-center text-[16vw] lg:text-[11vw] leading-[0.85] tracking-tight text-transparent select-none"
            style={{ WebkitTextStroke: "1px rgba(253,251,247,0.14)" }}
            data-testid="footer-ghost-wordmark"
          >
            ELYNCOR
          </p>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] text-[#FDFBF7]/45 tracking-wide">
          <span data-testid="footer-copyright">© ELYNCOR ELEMENTS. All rights reserved.</span>
          <span className="font-serif-display italic text-[#FDFBF7]/40">Handcrafted gemstone décor</span>
        </div>
      </div>
    </footer>
  );
}
